export default __webpack_public_path__ + "static/SectionTwo_01_04@2x-80577459558fe6b7c6374f0370ef2487.webp";